import { createContext, useContext } from "react";

interface UploadContextValue {
  openAddFiles: () => void;
}

// Default no-op so components rendered outside the provider (e.g. in isolation tests) don't throw.
export const UploadContext = createContext<UploadContextValue>({ openAddFiles: () => {} });

export function useUpload() {
  return useContext(UploadContext);
}
